var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-sheet-details"},[_c('section',{staticClass:"details-section"},[_c('TimeSheetDetailsBody',{attrs:{"time-sheet":_vm.currentTimeSheet}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }